import React, { useEffect, useState } from "react";
import { Heart, Droplet, Dumbbell, Timer, Award } from "lucide-react";
import { api } from "@/lib/api";
import { Card } from "@/pages/bitepal/Home";

const ICONS = { water: Droplet, barbell: Dumbbell, timer: Timer, fitness: Award };

export default function Community() {
  const [challenges, setChallenges] = useState([]);
  const [feed, setFeed] = useState([]);
  const [tab, setTab] = useState("challenges");
  const load = async () => { try { const [c, f] = await Promise.all([api("/community/challenges"), api("/community/feed")]); setChallenges(c); setFeed(f); } catch {} };
  useEffect(() => { load(); }, []);

  const toggleJoin = async (c) => { const path = c.joined ? "/community/challenges/leave" : "/community/challenges/join";
    setChallenges((cur) => cur.map((x) => x.id === c.id ? { ...x, joined: !x.joined } : x));
    try { await api(path, { method: "POST", body: { challenge_id: c.id } }); load(); } catch {} };
  const cheer = async (p) => { setFeed((cur) => cur.map((x) => x.id === p.id ? { ...x, cheered: !x.cheered, cheers: x.cheers + (x.cheered ? -1 : 1) } : x));
    try { await api("/community/feed/cheer", { method: "POST", body: { post_id: p.id } }); } catch {} };

  return (
    <div>
      <h1 className="text-3xl font-extrabold mb-4">Community</h1>
      <div className="flex gap-2 mb-4">
        {[["challenges", "Challenges"], ["feed", "Activity"]].map(([k, l]) =>
          <button key={k} onClick={() => setTab(k)} className={`flex-1 py-2.5 rounded-xl font-bold border ${tab === k ? "border-[#651F33] bg-[#651F33]/10 text-[#651F33]" : "border-[#E3D9C8] bg-white text-slate-500"}`}>{l}</button>)}
      </div>

      {tab === "challenges" && challenges.map((c) => { const Icon = ICONS[c.icon] || Award;
        return (
          <Card key={c.id} className="mt-3">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-2xl flex items-center justify-center" style={{ background: c.color + "22" }}><Icon size={20} style={{ color: c.color }} /></div>
              <div className="flex-1"><p className="font-bold">{c.title}</p><p className="text-xs text-slate-500">{c.description}</p></div>
            </div>
            {c.joined && <div className="mt-3"><div className="h-2 rounded-full bg-[#EAE1D2] overflow-hidden"><div className="h-full rounded-full" style={{ width: `${(c.progress / c.target) * 100}%`, background: c.color }} /></div>
              <p className="text-xs text-slate-500 mt-1.5">{c.progress} / {c.target}{c.completed ? "  ·  Completed! 🎉" : ""}</p></div>}
            <button data-testid={`community-join-${c.id}`} onClick={() => toggleJoin(c)} className={`w-full mt-3 py-2.5 rounded-full font-bold text-sm ${c.joined ? "bg-[#EAE1D2] text-slate-500" : "bg-[#651F33] text-[#F5F0E8]"}`}>{c.joined ? "Joined ✓ — Leave" : "Join Challenge"}</button>
          </Card>
        ); })}

      {tab === "feed" && feed.map((p) => (
        <Card key={p.id} className="mt-3 !p-4">
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center font-extrabold text-[#F5F0E8] ${p.mine ? "bg-[#651F33]" : "bg-[#A78BFA]"}`}>{p.avatar}</div>
            <div><p className="font-bold text-sm">{p.author}{p.mine ? " (you)" : ""}</p><span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-[#A78BFA]/20 text-[#A78BFA]">{p.tag}</span></div>
          </div>
          <p className="text-sm mt-3">{p.message}</p>
          <button data-testid={`community-cheer-${p.id}`} onClick={() => cheer(p)} className="mt-3 pt-3 border-t border-[#E3D9C8] flex items-center gap-2 text-sm font-semibold" style={{ color: p.cheered ? "#F43F5E" : "#64748B" }}>
            <Heart size={18} fill={p.cheered ? "#F43F5E" : "none"} /> {p.cheers} cheers
          </button>
        </Card>
      ))}
    </div>
  );
}
